import { useEffect, useState } from "react";
import { Plus, PencilSimple, Trash, X, GraduationCap, YoutubeLogo, Broadcast } from "@phosphor-icons/react";
import { api, apiError } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { toast } from "sonner";

const SECTIONS = [
  { type: "kajian", label: "Kajian Parenting (YouTube)", icon: GraduationCap, hint: "https://youtube.com/watch?v=..." },
  { type: "live", label: "Live Streaming (YouTube Live)", icon: YoutubeLogo, hint: "https://youtube.com/live/..." },
  { type: "radio", label: "Radio Streaming (URL MP3/AAC)", icon: Broadcast, hint: "https://stream.../radio.mp3" },
];

export default function ManageKajianRadio() {
  const [links, setLinks] = useState([]);
  const [modal, setModal] = useState(null); // {type, id?, name, url}
  const load = () => api.get("/radio/links").then((r) => setLinks(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!modal.name.trim() || !modal.url.trim()) { toast.error("Isi judul & link"); return; }
    const body = { name: modal.name.trim(), url: modal.url.trim(), type: modal.type, desc: (modal.desc || "").trim() };
    try {
      if (modal.id) await api.put(`/radio/links/${modal.id}`, body);
      else await api.post("/radio/links", body);
      toast.success("Tersimpan"); setModal(null); load();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  const del = async (id) => { if (!window.confirm("Yakin mau dihapus?")) return; await api.delete(`/radio/links/${id}`); toast.success("Dihapus"); load(); };

  return (
    <div>
      <PageHeader title="Kelola Kajian & Radio" />
      <div className="px-5 pt-4 pb-10 space-y-6">
        {SECTIONS.map((sec) => {
          const items = links.filter((l) => l.type === sec.type);
          return (
            <div key={sec.type} data-testid={`mkr-section-${sec.type}`}>
              <div className="flex items-center gap-2 mb-2">
                <sec.icon size={20} weight="duotone" className="text-primary" />
                <h3 className="font-heading font-bold text-stone-800 text-sm flex-1">{sec.label}</h3>
                <button data-testid={`mkr-add-${sec.type}`} onClick={() => setModal({ type: sec.type, name: "", url: "", desc: "" })}
                  className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center active:scale-90 transition-transform"><Plus size={18} weight="bold" /></button>
              </div>
              <div className="space-y-2">
                {items.length === 0 && <p className="text-stone-400 text-sm">Belum ada.</p>}
                {items.map((l) => (
                  <div key={l.id} data-testid={`mkr-item-${l.id}`} className="bg-white rounded-2xl border border-stone-200/60 p-3 flex items-center gap-2 shadow-sm">
                    <div className="flex-1 min-w-0"><p className="font-semibold text-stone-800 text-sm truncate">{l.name}</p>
                      <p className="text-stone-400 text-xs truncate">{l.url}</p></div>
                    <button data-testid={`mkr-edit-${l.id}`} onClick={() => setModal({ type: l.type, id: l.id, name: l.name, url: l.url, desc: l.desc || "" })}
                      className="w-8 h-8 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0"><PencilSimple size={15} weight="bold" /></button>
                    <button data-testid={`mkr-del-${l.id}`} onClick={() => del(l.id)} className="w-8 h-8 rounded-lg bg-red-50 text-destructive flex items-center justify-center shrink-0"><Trash size={15} weight="bold" /></button>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>

      {modal && (
        <div className="fixed inset-0 z-[60] bg-black/40 flex items-end md:items-center justify-center" onClick={() => setModal(null)}>
          <div onClick={(e) => e.stopPropagation()} className="bg-white w-full md:max-w-md rounded-t-3xl md:rounded-3xl p-5">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-heading font-bold text-lg text-stone-800">{modal.id ? "Edit Link" : "Tambah Link"}</h3>
              <button onClick={() => setModal(null)}><X size={22} className="text-stone-400" /></button>
            </div>
            <p className="text-xs text-stone-400 mb-1">Judul</p>
            <input data-testid="mkr-name" value={modal.name} onChange={(e) => setModal({ ...modal, name: e.target.value })}
              placeholder="mis. Kajian Parenting Islami" className="w-full bg-stone-50 border border-stone-200 rounded-xl py-2.5 px-3 mb-3 outline-none focus:border-primary" />
            <p className="text-xs text-stone-400 mb-1">Link / URL</p>
            <input data-testid="mkr-url" value={modal.url} onChange={(e) => setModal({ ...modal, url: e.target.value })}
              placeholder={SECTIONS.find((s) => s.type === modal.type)?.hint} className="w-full bg-stone-50 border border-stone-200 rounded-xl py-2.5 px-3 mb-4 outline-none focus:border-primary" />
            {modal.type === "radio" && (<>
              <p className="text-xs text-stone-400 mb-1">Deskripsi singkat (opsional)</p>
              <input data-testid="mkr-desc" value={modal.desc || ""} onChange={(e) => setModal({ ...modal, desc: e.target.value })}
                placeholder="mis. Kajian & Murottal" className="w-full bg-stone-50 border border-stone-200 rounded-xl py-2.5 px-3 mb-4 outline-none focus:border-primary" />
            </>)}
            <button data-testid="mkr-save" onClick={save} className="w-full bg-primary text-white font-semibold py-3.5 rounded-full active:scale-95 transition-transform">Simpan</button>
          </div>
        </div>
      )}
    </div>
  );
}
